import { motion } from "framer-motion";
import { useLanguage } from "../lib/LanguageContext";
import { CONTACT } from "../lib/translations";

const IMGS = [
  "/catalog/img4.jpg",
  "/catalog/img6.jpg",
  "/catalog/img9.jpg",
  "/catalog/img10.jpg",
  "/catalog/img12.jpg",
  "/catalog/img13.jpg",
];

export default function InstagramGrid() {
  const { t } = useLanguage();
  return (
    <section data-testid="instagram-section" className="bg-paper py-28 md:py-36">
      <div className="max-w-[1480px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid md:grid-cols-12 gap-6 items-end mb-12">
          <div className="md:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-8 h-px bg-warmbrown" />
              <span className="eyebrow">{t.instagram.eyebrow}</span>
            </div>
            <h2 className="font-serif text-3xl md:text-5xl tracking-tight text-ink">{t.instagram.title}</h2>
            <p className="font-body italic text-ink-soft mt-4 max-w-md">{t.instagram.sub}</p>
          </div>
          <div className="md:col-span-5 md:text-right">
            <a href={`https://instagram.com/${CONTACT.instagramHandle}`} target="_blank" rel="noreferrer"
              data-testid="instagram-follow"
              className="inline-flex items-center gap-3 text-[11px] tracking-[0.3em] uppercase font-semibold border-b border-ink pb-1 text-ink hover:text-warmbrown hover:border-warmbrown transition-colors duration-500">
              {t.instagram.follow} →
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {IMGS.map((src, i) => (
            <motion.a
              key={i}
              href={`https://instagram.com/${CONTACT.instagramHandle}`}
              target="_blank" rel="noreferrer"
              data-testid={`instagram-tile-${i}`}
              initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: i * 0.06 }}
              className="relative aspect-square overflow-hidden group"
            >
              <img src={src} alt={`Amaranto on Instagram ${i + 1}`}
                className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
              <div className="absolute inset-0 bg-dustyrose/0 group-hover:bg-dustyrose/25 transition-colors duration-700" />
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
